import classnames from 'classnames';

import { getCursorClass } from 'Components/utils/form/form.util';

export const themes = {
  default: props => ({
    thInputWrapper: 'relative decorator-slash-separator flex-1 h-full',
    thInput: classnames(
      'reset-input h-full text-center text-current w-full',
      getCursorClass(props),
    ),
  }),
};
